import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { message } from "ant-design-vue";
import "@/config/antdLazyUse"; // 按需引入antd组件
import "@/assets/global.less";
import "@/assets/iconfont/iconfont.css";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn"); // 中文化
import md5 from "md5";
import BaiduMap from "vue-baidu-map";
import global from "./utils/global";
import { BmlMarkerClusterer } from "vue-baidu-map";
import VueLazyload from "vue-lazyload"; //图片懒加载
Vue.component("bml-marker-clusterer", BmlMarkerClusterer);
// 全局过滤器
import * as filters from "./utils/filters.js";
// 放大镜功能
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
Vue.prototype.$message = message;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;

Vue.use(BaiduMap, {
  // ak: "X4FIZhcPdZiRVnPePW0PGhZhniDwrelU",
  // ak: "TeUeOXzC6E7HEUNQpPBu0yWHxozF57B8",
  // ak: "5w1gBInHWqHp3NBgANGrxBIriTdvirhh",
  ak: "z1zWV2F71OqGbn192Q9TKDdFQczEK7GN",
});
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: require("../src/assets/images/user_img.png"),
  loading: require("../src/assets/images/imgloading.gif"),
  attempt: 1,
});

Vue.use(Viewer);

Vue.use(global);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
